import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { NumberBoxAmount } from './NumberBox.Amount/NumberBox.Amount.es.js';
import { NumberBoxProvider } from './NumberBox.Context/NumberBox.Context.es.js';
import { NumberBoxCustomAmount } from './NumberBox.CustomAmount/NumberBox.CustomAmount.es.js';
import { NumberBoxGenericAmount } from './NumberBox.Generic/NumberBox.GenericAmount.es.js';
import { NumberBoxTitle } from './NumberBox.Title/NumberBox.Title.es.js';

const NumberBox = ({ className, children, size = 'sm', loading = false, fallback = '--', ...rest })=>{
    return jsx(NumberBoxProvider, {
        fallback: fallback,
        loading: loading,
        size: size,
        children: jsx("div", {
            className: classNames('cb-number-box', className, size),
            ...rest,
            children: children
        })
    });
};
NumberBox.displayName = 'NumberBox';
NumberBox.Amount = NumberBoxAmount;
NumberBox.CustomAmount = NumberBoxCustomAmount;
NumberBox.GenericAmount = NumberBoxGenericAmount;
NumberBox.Title = NumberBoxTitle;

export { NumberBox, NumberBox as default };
//# sourceMappingURL=NumberBox.es.js.map
